module.exports = __webpack_public_path__ + "img/rc3.f3aa6ac2.png";